export function buildAttachmentFile(f, description, idx) {
  const baseName = f?.name
    .replaceAll('_', '-')
    .split('.')
    .slice(0, -1)
    .join('.');
  const isXLSXSheet = f?.type.split('.').pop() === 'sheet' ? 'xlsx' : null;
  const isXLSSheet = f?.type.split('.').pop() === 'ms-excel' ? 'xls' : null;
  const ext = isXLSXSheet || isXLSSheet || f?.type.split('/')[1];
  const formatted = `${Date.now()}${idx}:${description}.${ext}`;
  const name = baseName ? `${baseName}-${formatted}` : formatted;
  return new File([f?.blob], name, { type: f?.type });
}

/**
 * Builds multipart FormData for occurrence with attachments and NF links.
 * Each file entry gets a corresponding fileMetadata[n][nfsIds] entry.
 */
export function buildOccurrenceFormData(files) {
  const formData = new FormData();
  let fileCounter = 0;

  files.forEach((file, index) => {
    if (file?.file?.length > 1) {
      file.file.forEach((f, idx) => {
        formData.append('file', buildAttachmentFile(f, file.description, idx));

        (file.selectedNfIds || []).forEach((nfId, nfIdx) => {
          formData.append(
            `fileMetadata[${fileCounter}][nfsIds][${nfIdx}]`,
            String(nfId)
          );
        });

        fileCounter++;
      });
    } else {
      const f = file?.file?.[0];
      formData.append('file', buildAttachmentFile(f, file.description, index));

      (file.selectedNfIds || []).forEach((nfId, nfIdx) => {
        formData.append(
          `fileMetadata[${fileCounter}][nfsIds][${nfIdx}]`,
          String(nfId)
        );
      });

      fileCounter++;
    }
  });

  return formData;
}
